/*
 * @Author: your name
 * @Date: 2021-02-21 09:17:51
 * @LastEditTime: 2021-04-26 16:31:58
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \CJYXCommon\src\utils\UUID.ts
 */

import { v1 as uuidv1, v5 as uuidv5 } from 'uuid';

export default {
  getUUID32 () {
    return `sid-${uuidv1().split('-').join('')}`;
    // return uuidv5('cjyx', uuidv5.URL).split('-').join('');
  },
  getNowTime () {
    let dateTime;
    let hh = new Date().getHours() < 10 ? '0' + new Date().getHours():new Date().getHours()
    let mm = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes():new Date().getMinutes()
    let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds():new Date().getSeconds()
    dateTime = 'id:' + hh + mm + ss;
    return dateTime;
  }
}